import { render, staticRenderFns } from "./CmgHome.vue?vue&type=template&id=7c063028&scoped=true&lang=pug&"
import script from "./cmg-home.ts?vue&type=script&lang=ts&"
export * from "./cmg-home.ts?vue&type=script&lang=ts&"
import style0 from "./CmgHome.vue?vue&type=style&index=0&id=7c063028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c063028",
  null
  
)

export default component.exports